
$(".imageTextSlider__arrow-left").on("click", () => {
    let currentIndex = 0

    let slidesButtons = document.querySelectorAll(".imageTextSlider__dots > ul > li > button");
    slidesButtons.forEach((slideBtn) => {
        if (slideBtn.ariaSelected) {
            currentIndex = parseInt(slideBtn.innerHTML) - 1
        }
    })
    if (currentIndex - 1 >= 0) {
        slidesButtons[currentIndex - 1].click()
    }
})

$(".imageTextSlider__arrow-right").on("click", () => {

    let currentIndex = 0
    let max = 0

    let slidesButtons = document.querySelectorAll(".imageTextSlider__dots > ul > li > button");
    slidesButtons.forEach((slideBtn) => {
        let index = parseInt(slideBtn.innerHTML) - 1
        if (slideBtn.ariaSelected) {
            currentIndex = index
        }
        if (index > max) {
            max = index
        }
    })
    if (currentIndex + 1 <= max) {
        slidesButtons[currentIndex + 1].click()
    }
})